<template>
  <v-app>
    <v-content>
      <v-container color="grey" fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <material-card offset="75" class="ma-2 pa-3">
              <v-avatar
                tile
                color="white"
                slot="offset"
                size="160"
                width="400"
                class="mx-auto d-block elevation-8"
              >
                <v-img contain width="90%" :src="imgSrc"></v-img>
              </v-avatar>

              <v-card-text class="text-xs-center">
                <h4 class="font-weight-light mb-3">PARTNER KARTY</h4>

                <h2 class="mb-3 break-word">{{ data.name }}</h2>
              </v-card-text>

              <v-flex xs12>
                <v-select
                  v-model="placeId"
                  label="Wybierz obiekt"
                  item-text="name"
                  item-value="id"
                  :items="items"
                ></v-select>
              </v-flex>

              <v-flex xs12 md12 lg12 text-xs-center>
                <v-btn type="submit" large color="success mx-3" @click="saveId">Zatwierdź</v-btn>
              </v-flex>
            </material-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import { SessionStorage } from '@witkac/kartamiejska-shared';

import store from '@/store/store';
import MaterialCard from '@/components/material/Card';
import { notificationsMixin } from '@/mixins/notifications';
import { config } from '@/utils/config';

// @vuese
// Wyświetlanie selecta z wyborem obiektu
// @group Partners
export default {
  components: { MaterialCard },

  data() {
    return {
      placeId: undefined
    };
  },
  mixins: [notificationsMixin],
  computed: {
    ...mapState({
      items: state => state.partners.places.list,
      count: state => state.partners.places.count,
      partnerId: state => state.partners.id,
      data: state => state.partners.data
    }),
    imgSrc() {
      if (this.data.mainImage) {
        return `${config.mediaURL}/${this.data.mainImage}`;
      }
      return '/img/logo' + Math.floor(Math.random() * 4 + 1) + '.png';
    }
  },
  methods: {
    // @vuese
    // Zapisuje id obiektu do SessionStorage
    saveId() {
      if (this.placeId) {
        sessionStorage.setItem(SessionStorage.PLACE_ID, '' + this.placeId);
        this.$router.push('dashboard');
      } else {
        this.notifyError('Nie wybrano obiektu');
      }
    },
    // @vuese
    // Sprawdza czy istnieje więcej, niż jeden obiekt
    checkPlaces() {
      if (this.count === 1) {
        this.placeId = this.items[0].id;
        this.saveId();
      }
    }
  },
  mounted() {
    this.checkPlaces();
  }
};
</script>
